import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'router-transition',
  setup(__props) {

const keepAliveComponents = ref<any[]>([]);
const route = useRoute();
const routeQuery = route.query as {
  force?: number; // route: 重载标识，用于强制刷新组件
};

watch(
  () => route,
  to => {
    if (
      to.meta.keepAlive &&
      keepAliveComponents.value.indexOf(to.name) === -1
    ) {
      keepAliveComponents.value.push(to.name);
    }
    // TODO: 监听from，处理删除keepAliveComponents。
    // TODO: 不要了，写个hook处理数据放到query中，通过query处理回显参数
  },
  { deep: true, immediate: true }
);
// route: 处理缓存组件与重载组件
const forceRefreshKey = computed(() => {
  return route.fullPath + (routeQuery.force ? `_${routeQuery.force}` : '');
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "router" }, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, {
        include: keepAliveComponents.value,
        max: 5
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: forceRefreshKey.value }))
      ], 1032, ["include"]))
    ]),
    _: 1
  }))
}
}

})